import type { BootstrapResponse } from './types';
import type { ThemeTokenMap } from '@/shared/theme/theme-tokens';

export const APP_PREVIEW_MESSAGE = 'FC_APP_RUNTIME_PREVIEW';
export const APP_PREVIEW_READY_MESSAGE = 'FC_APP_PREVIEW_READY';
export const APP_PREVIEW_NODE_SELECT_MESSAGE = 'FC_APP_PREVIEW_NODE_SELECT';

export interface SkinPreviewAsset {
  fileName: string;
  id: string;
  label: string;
  role: string;
  url: string;
}

export interface SkinPreviewItem {
  assetId?: string;
  badge?: string;
  enabled?: boolean;
  id: string;
  label: string;
  meta?: string;
  provider?: string;
  target?: string;
}

export interface SkinPreviewComponent {
  id: string;
  props: {
    activeItem?: string;
    amountText?: string;
    badgeText?: string;
    columns?: number;
    copy?: string;
    ctaText?: string;
    fallbackAssetId?: string;
    imageAssetId?: string;
    items?: SkinPreviewItem[];
    logoAssetId?: string;
    avatarAssetId?: string;
    showBadge?: boolean;
    showBalance?: boolean;
    showCountdown?: boolean;
    showProvider?: boolean;
    statusText?: string;
    subtitle?: string;
    target?: string;
    template: string;
    title?: string;
  };
  slot: string;
  type: string;
  visible: boolean;
}

export interface SkinPreviewPage {
  components: SkinPreviewComponent[];
  id: string;
  route: string;
}

export interface SkinPreviewDraft {
  assets: SkinPreviewAsset[];
  pages: SkinPreviewPage[];
  previewState?: string;
  selectedComponentId?: string;
  selectedItemId?: string;
  selectedPageId?: string;
}

export interface AppPreviewRuntimePayload {
  route?: string;
  runtime: BootstrapResponse;
  skinDraft?: SkinPreviewDraft;
  themeTokens?: ThemeTokenMap;
}

export interface AppPreviewRuntimeMessage {
  payload: AppPreviewRuntimePayload;
  type: typeof APP_PREVIEW_MESSAGE;
}

export interface AppPreviewNodeSelectMessage {
  payload: {
    componentId: string;
    itemId?: string;
  };
  type: typeof APP_PREVIEW_NODE_SELECT_MESSAGE;
}

export function isAppPreviewRuntimeMessage(
  value: unknown,
): value is AppPreviewRuntimeMessage {
  return (
    typeof value === 'object' &&
    value !== null &&
    (value as { type?: string }).type === APP_PREVIEW_MESSAGE &&
    typeof (value as { payload?: unknown }).payload === 'object'
  );
}
